import React, { useEffect, useState } from 'react';

import useAdminProductLabelTemplateService from '@hooks/admin/product_label_templates/useAdminProductLabelTemplateService';
import ProductLabelTemplatesShow from '@shared/product_label_templates/ProductLabelTemplatesShow';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';

const ProductLabelTemplatesShowPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  // useAdminProductLabelTemplateService 是 .js 且 JSDoc 標 `@returns {Object}`，
  // TS 看不到方法欄位，cast 為 any 保留 runtime 行為。
  const { getById, delete: deleteTemplate } =
    useAdminProductLabelTemplateService() as any;
  const [productLabelTemplate, setProductLabelTemplate] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getById(id);
        if (response.success) {
          setProductLabelTemplate(response.data);
        }
      } catch (error) {
        console.error('Failed to load product label template:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <ProductLabelTemplatesShow
      productLabelTemplate={productLabelTemplate}
      role="admin"
      deleteTemplate={deleteTemplate}
    />
  );
};

export default ProductLabelTemplatesShowPage;
